import { gql } from "@apollo/client";

export const CREATE_COMENTARIO = gql`
    mutation createComentarioLogistica (
        $idDelegacion: Int!
        $idPaciente: Int!
        $comentario: String!
    ){
        createComentarioLogistica (
            idDelegacion: $idDelegacion
            idPaciente: $idPaciente
            comentario: $comentario
        )
    }
`;